import { HistoryProps } from '@/types'

export const groupHistoryByDay = (
  items: HistoryProps[] | undefined,
): HistoryProps[][] => {
  if (!items) {
    return []
  }

  const groups: { [date: string]: HistoryProps[] } = {}

  for (const item of items) {
    const date = new Date(item.createdAt).toISOString().split('T')[0]

    if (!groups[date]) {
      groups[date] = []
    }

    groups[date].push(item)
  }

  return Object.values(groups)
}
